import React from 'react';
import PropTypes from 'prop-types';
import type { MessageCardProps } from './MessageCard.types';
import './messageCard.scss';

const MessageCard = ({ avatar, name, online, description, time, messagesQuantity }: MessageCardProps) => {

  return (
    <div
      className="sb-messageCard"
      data-testid="sb-messageCard"
    >
      <div
        className="sb-messageCard__containerImage"
        data-testid="sb-messageCard__containerImage"
      >
        <img
          className="sb-messageCard__containerImage--img"
          data-testid="sb-messageCard__containerImage--img"
          src={avatar}
          alt={name}
        />
        {online &&
          <span
            className="sb-messageCard__containerImage--online"
            data-testid="sb-messageCard__containerImage--online"
          />
        }
      </div>
      <div
        className="sb-messageCard__container"
        data-testid="sb-messageCard__container"
      >
        <p
          className="sb-messageCard__container--name"
          data-testid="sb-messageCard__container--name"
        >
          {name}
        </p>
        <p
          className="sb-messageCard__container--description"
          data-testid="sb-messageCard__container--description"
        >
          {description}
        </p>
      </div>
      <div
        className="sb-messageCard__messagesQuantity"
        data-testid="sb-messageCard__messagesQuantity"
      >
        {time}
        <span
          className="sb-messageCard__messagesQuantity--quantity"
          data-testid="sb-messageCard__messagesQuantity--quantity"
        >
          {messagesQuantity}
        </span>
      </div>
    </div>
  );
};

MessageCard.propTypes = {
  /**
 * avatar
 */
  avatar: PropTypes.string,
  /**
* name
*/
  name: PropTypes.string,
  /**
* online?
*/
  online: PropTypes.bool,
  /**
* description
*/
  description: PropTypes.string,
  /**
* time
*/
  time: PropTypes.string,
  /**
* messagesQuantity
*/
  messagesQuantity: PropTypes.number,
};

MessageCard.defaultProps = {
  avatar: "",
  name: "",
  online: true,
  description: "",
  time: "",
  messagesQuantity: 10
};

export default MessageCard;